import {useEffect} from 'react'
import {useSelector} from 'react-redux'
import actions from 'redux-auto'

export function useRessourcenPlan() {
  const ressourcenPlan = useSelector(state => state.ressourcen.ressourcenPlan)
  const isLoading = useSelector(state => state.ressourcen.isLoading)
  useEffect(() => {
    if (!ressourcenPlan.ressourcenOfAbteilung && !isLoading) {
      actions.ressourcen.getMeinenRessourcenPlan()
    }
  }, [ressourcenPlan, isLoading])

  return {ressourcenPlan, isLoading}
}
